import React, {
  useState,
  useRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import InputField from '../elements/inputField';

export interface InputFieldProps
  extends InputHTMLAttributes<HTMLInputElement> {}

const InputFieldPassword = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ onBlur, onChange, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    return (
      <div className="form_bx">
        <div className="form_inpt">
          <div className="embed-contrase-a w-embed">
            <InputField
              dataName={props.name ?? ''}
              name={props.name ?? ''}
              ref={ref ?? inputRef}
              type={showPassword ? 'text' : 'password'}
              onBlur={onBlur}
              onChange={onChange} // ✅ ESTA LÍNEA ES CLAVE
              placeholder={'Ingresa tu contraseña'}
              id={props.name ?? ''}
              pattern="^[a-zA-Z0-9\-+=|\\(){}[\]:;*\.]+$"
            />
          </div>
          <img
            src="/documents/d/guest/ojo-icono"
            className="form_inpt-ojoabierto"
            onClick={togglePasswordVisibility}
            style={{ display: showPassword ? 'none' : 'block' }}
            alt="Mostrar contraseña"
          />
          <img
            src="/documents/d/guest/ojo-cruzado-1"
            className="form_inpt-ojo"
            onClick={togglePasswordVisibility}
            style={{ display: showPassword ? 'block' : 'none' }}
            alt="Ocultar contraseña"
          />
        </div>
      </div>
    );
  }
);

export default InputFieldPassword;
